import { fmeaComponentTemplatesConstants } from './fmeaComponentTemplates.actions';

const initial = { loading: false, data: [], error: null };

export function fmeaComponentTemplatesReducer(state = initial, action) {
  switch (action.type) {
    case fmeaComponentTemplatesConstants.LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case fmeaComponentTemplatesConstants.LIST_SUCCESS:
      return { loading: false, data: action.data || [], error: null };
    case fmeaComponentTemplatesConstants.LIST_FAILURE:
      return { loading: false, data: [], error: action.error };
    case fmeaComponentTemplatesConstants.UPDATE_SUCCESS:
      return {
        ...state,
        data: state.data.map(t => (t.id === action.data.id ? action.data : t)),
      };
    case fmeaComponentTemplatesConstants.DELETE_SUCCESS:
      return { ...state, data: state.data.filter(t => t.id !== action.templateId) };
    default:
      return state;
  }
}
